// Basic
import { useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import actionsUsers from '@/app/modules/users/monetic/api/actionsUsers';
// Libs
import { cn } from '../../../../../../common-utils/libraries/tailwind/utils';
// Components
import HeaderTitle from '../../../../../../common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import FooterForm from '../../../../../../common-utils/components/renders/modal/components/footers/FooterForm/FooterForm';
import Entity from '../../../../../../common-utils/components/renders/entity/Entity';
import { Modal, ModalBody, ModalContent, ModalTrigger } from '../../../../../../common-utils/components/ui/modal';
// Common
import ICONS from '@/common-utils/enums/icons';
// Lang
import { nsUser } from '@/app/i18n/namespaces';

/**
 * @param {JSX.Element} trigger element that triggers modal opening
 * @returns {JSX.Element} ModalResetPassword Component
 */
function ModalResetPassword({ trigger, isOpen, setIsOpen, userId, userEmail }) {

    // State
    const [bodyContent, setBodyContent] = useState(
        <>
            <Entity entity={'modal.reset_password.text'} namespace={nsUser} />
            <div className='my-4'>{userEmail}</div>
            <Entity
                entity='modal.reset_password.warning'
                namespace={nsUser}
                icon={ICONS.WARNING}
                iconClassName='text-warning mr-1'
            />
        </>
    );
    const [showSubmitButton, setShowSubmitButton] = useState(true);

    // API Calls
    const onSuccess = () => {
        setShowSubmitButton(false);
        setBodyContent(<Entity entity={'modal.reset_password.success'} namespace={nsUser} data={{ userEmail: userEmail }} />);
    };
    const onError = () => {
        setShowSubmitButton(false);
        setBodyContent(<Entity entity={'modal.reset_password.error'} namespace={nsUser} />);
    };
    const submitResetPassword = actionsUsers.resetPassword(onSuccess, onError);

    // Renders
    const content =
        <ModalContent className={cn('max-w-lg')}>
            <HeaderTitle title={'modal.reset_password.title'} namespace={nsUser} />
            <ModalBody>
                {bodyContent}
            </ModalBody>
            <FooterForm
                onSubmit={() => submitResetPassword.mutate(userId)}
                isSubmitting={submitResetPassword.isLoading}
                showSubmitButton={showSubmitButton}
            />
        </ModalContent>;

    if (trigger) {
        return (
            <Modal>
                <ModalTrigger>{trigger}</ModalTrigger>
                {content}
            </Modal>
        );
    }

    return (
        <Modal open={isOpen} onOpenChange={setIsOpen}>
            {content}
        </Modal>
    );
}

ModalResetPassword.propTypes = {
    trigger: PropTypes.node,
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    userId: PropTypes.string,
    userEmail: PropTypes.string
};

export default ModalResetPassword;